module.exports = __webpack_public_path__ + "static/media/sevenIcon.4561d2c4.jpg";